import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './main.js';
import __var_2__ from './ndarray.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Apply a unary function accepting and returning single-precision floating-point numbers to each element in a single-precision floating-point strided input array according to a corresponding element in a strided mask array and assign each result to an element in a single-precision floating-point strided output array.
*
* @module @stdlib/strided/base/smskmap
*
* @example
* var Float32Array = require( '@stdlib/array/float32' );
* var Uint8Array = require( '@stdlib/array/uint8' );
* var smskmap = require( '@stdlib/strided/base/smskmap' );
*
* function scale( x ) {
*     return x * 10.0;
* }
*
* var x = new Float32Array( [ 1.0, 2.0, 3.0, 4.0, 5.0 ] );
* var m = new Uint8Array( [ 0, 0, 1, 0, 0 ] );
* var y = new Float32Array( x.length );
*
* smskmap( x.length, x, 1, m, 1, y, 1, scale );
*
* console.log( y );
* // => <Float32Array>[ 10.0, 20.0, 0.0, 40.0, 50.0 ]
*
* @example
* var Float32Array = require( '@stdlib/array/float32' );
* var Uint8Array = require( '@stdlib/array/uint8' );
* var smskmap = require( '@stdlib/strided/base/smskmap' );
*
* function scale( x ) {
*     return x * 10.0;
* }
*
* var x = new Float32Array( [ 1.0, 2.0, 3.0, 4.0, 5.0 ] );
* var m = new Uint8Array( [ 0, 0, 1, 0, 0 ] );
* var y = new Float32Array( x.length );
*
* smskmap.ndarray( x.length, x, 1, 0, m, 1, 0, y, 1, 0, scale );
*
* console.log( y );
* // => <Float32Array>[ 10.0, 20.0, 0.0, 40.0, 50.0 ]
*/

// MODULES //
var setReadOnly = __var_0__;
var main = __var_1__;
var ndarray = __var_2__;


// MAIN //

setReadOnly( main, 'ndarray', ndarray );


// EXPORTS //
export default main;
